export enum PaymentProcessorType {
    NONE = 'none',
    UNSUPPORTED = 'unsupported',
}
